import { ResetPassword } from '../../../../interfaces/auth.interface';
import { Validation } from '../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING, APP_ERROR_MESSAGES, Regex } from "../../../../utils/appConstant"

export const validateResetPasswordForm = (formData: ResetPassword, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.newPassword) {
    if (!formData.newPassword || (formData.newPassword && !formData.newPassword)) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.newPassword, message: APP_ERROR_MESSAGES.resetPassword.blankNewPassword }) }
    else if (!Regex.password.test(formData.newPassword)) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.newPassword, message: APP_ERROR_MESSAGES.resetPassword.passwordFormat })
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.confirmPassword) {
    if (!formData.confirmPassword || (formData.confirmPassword && !formData.confirmPassword)) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.confirmPassword, message: APP_ERROR_MESSAGES.resetPassword.blankConfirmPassword }) }
  }

  if (
    formData.newPassword &&
    formData.confirmPassword &&
    formData.newPassword !== formData.confirmPassword
  ) {
    if (fieldToValidate === VALIDATION_FIELD_MAPPING.newPassword || !fieldToValidate) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.newPassword,
        message: APP_ERROR_MESSAGES.resetPassword.mismatchNewPassword,
      });
    }
    if (fieldToValidate === VALIDATION_FIELD_MAPPING.confirmPassword || !fieldToValidate) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.confirmPassword,
        message: APP_ERROR_MESSAGES.resetPassword.mismatchConfirmPassword,
      });
    }
  }

  return validations
}